
(function() {
  var result = { translations: { "et": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} p\xE4eva", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}p", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Kv{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, laiend {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "et": "static-7.1162"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1162",
    "ar-eg": "static-7.1162",
    "bg": "static-7.1162",
    "bn": "static-7.1162",
    "ca-es": "static-7.1162",
    "cs": "static-7.1162",
    "da": "static-7.1162",
    "de": "static-7.1162",
    "el": "static-7.1162",
    "en-gb": "static-7.1162",
    "en": "static-7.1162",
    "es-mx": "static-7.1162",
    "es": "static-7.1162",
    "et": "static-7.1162",
    "fi": "static-7.1162",
    "fr-ca": "static-7.1162",
    "fr": "static-7.1162",
    "he-il": "static-7.1162",
    "hi": "static-7.1162",
    "hr": "static-7.1162",
    "hu": "static-7.1162",
    "id": "static-7.1162",
    "it": "static-7.1162",
    "ja": "static-7.1162",
    "ko": "static-7.1162",
    "lt": "static-7.1162",
    "ms": "static-7.1162",
    "nl": "static-7.1162",
    "no": "static-7.1162",
    "pl": "static-7.1162",
    "pt-br": "static-7.1162",
    "pt-pt": "static-7.1162",
    "ro": "static-7.1162",
    "ru": "static-7.1162",
    "sk": "static-7.1162",
    "sl": "static-7.1162",
    "sv": "static-7.1162",
    "th": "static-7.1162",
    "tl": "static-7.1162",
    "tr": "static-7.1162",
    "uk": "static-7.1162",
    "vi": "static-7.1162",
    "x-pseudo": "static-7.1162",
    "zh-cn": "static-7.1162",
    "zh-hk": "static-7.1162",
    "zh-tw": "static-7.1162"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:et', {version: 'static-7.1162'}); }
})();


